import { JSX } from 'react';
import { FaBookOpen, FaChartSimple, FaGear, FaSquareCheck, FaUser } from 'react-icons/fa6';
import { useShallow } from 'zustand/shallow';
import { useNavigation } from '../hooks/navigation.hook';
import { useScroll } from '../hooks/scroll.hook';
import { useAppStore } from '../stores/app.store';

export function Footer(): JSX.Element {
  const { navigate } = useNavigation();
  const { scrollsBottom } = useScroll();

  const [news, hideFooter, activeMenu, hiddenMenus, isDark] = useAppStore(
    useShallow((s) => [s.news, s.hideFooter, s.activeMenu, s.hiddenMenus, s.isDark]),
  );

  const shadow = isDark ? 'shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.6)]' : 'shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]';

  const menuItems = [
    { name: 'habits', icon: FaSquareCheck },
    { name: 'statistic', icon: FaChartSimple },
    { name: 'partners', icon: FaUser },
    { name: 'readings', icon: FaBookOpen },
    { name: 'settings', icon: FaGear },
  ].filter((i) => !hiddenMenus?.includes(i.name));

  return hideFooter ? (
    <></>
  ) : (
    <div className={`sticky bottom-0 bg-base-200 z-10 ${scrollsBottom ? shadow : ''}`}>
      <ul className="width-limiter menu menu-horizontal w-full flex justify-around">
        {menuItems.map((item) => (
          <li key={item.name}>
            <a
              className={`flex active:bg-primary! active:text-primary-content! bg-base-200! ${
                activeMenu === item.name ? 'text-primary' : 'text-base-content/50'
              }`}
              onClick={() => navigate(`/${item.name}`)}
            >
              <div className="indicator">
                {Boolean(news[item.name]) && (
                  <span className="indicator-item badge badge-xs badge-accent">{news[item.name]}</span>
                )}
                <item.icon size={'2rem'} />
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
